/**
 * @Relay no-runtime
 */
/**
 * @graphql cc
 */
import { useCallback } from 'react';
import graphql from 'graphql-tag';

import { getApolloClient } from '@confluence/graphql';
import { getMonitoringClient } from '@confluence/monitoring';
import { Attribution } from '@confluence/error-boundary';

import type {
	useGetSpaceIdsFromSpaceKeysQuery as useGetSpaceIdsFromSpaceKeysQuery$data,
	useGetSpaceIdsFromSpaceKeysQueryVariables as useGetSpaceIdsFromSpaceKeysQuery$variables,
} from './__types__/useGetSpaceIdsFromSpaceKeysQuery';

const UseGetSpaceIdsFromSpaceKeysQuery = graphql`
	query useGetSpaceIdsFromSpaceKeysQuery($spaceKeys: [String]) {
		spaces(spaceKeys: $spaceKeys) {
			nodes {
				id
			}
		}
	}
`;

export const useGetSpaceIdsFromSpaceKeys = () => {
	const getSpaceIdsFromSpaceKeys = useCallback(async (spaceKeys: string[]): Promise<string[]> => {
		const apolloClient = getApolloClient();

		if (spaceKeys.length === 0) {
			return [];
		}

		try {
			const { data } = await apolloClient.query<
				useGetSpaceIdsFromSpaceKeysQuery$data,
				useGetSpaceIdsFromSpaceKeysQuery$variables
			>({
				query: UseGetSpaceIdsFromSpaceKeysQuery,
				variables: { spaceKeys },
			});

			const spaceIds: string[] = (data.spaces?.nodes ?? [])
				.map((node) => node?.id)
				.filter((id): id is string => !!id);

			return spaceIds;
		} catch (error) {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.COMPANY_HUB,
			});
		}

		return [];
	}, []);

	return getSpaceIdsFromSpaceKeys;
};
